export default "__VITE_ASSET__D17Ft99y__"